// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"223":"commons","245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx"}[chunkId] + "-" + {"223":"9eb0214d163bbf898bb4","245":"d153c708f8e7e7266836","453":"ab66c4d2c855d07fd066"}[chunkId] + ".js";
};